<template>
  <svg
    class="custom-icon"
    width="38"
    height="30"
    viewBox="0 0 38 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.4503 28.1308L29.4405 20.8527C31.299 18.9177 31.299 15.8608 29.4405 13.9257L16.0902 0.0254928L21.4391 0.0756636C22.4589 0.0850178 23.4343 0.511045 24.1555 1.26193L36.8605 14.4903C38.3798 16.0722 38.3798 18.6371 36.8605 20.2191L28.6068 28.8128C27.0874 30.3947 24.624 30.3947 23.1046 28.8128L22.4503 28.1308ZM1.13949 15.6143C0.401442 14.8459 -0.00904807 13.8011 0.000151357 12.7143L0.0728407 4.01467C0.0918975 1.77739 1.84944 -0.0200045 3.99793 0.000168154L12.1499 0.0764176C13.1697 0.0857718 14.1451 0.511799 14.8663 1.26269L27.5713 14.491C29.0906 16.073 29.0906 18.6379 27.5713 20.2198L19.3176 28.8135C17.7982 30.3955 15.3348 30.3955 13.8154 28.8135L1.13949 15.6143ZM7.47036 4.2915C6.51781 3.2997 4.97342 3.2997 4.02086 4.2915C3.0683 5.2833 3.0683 6.89131 4.02086 7.88311C4.97342 8.8749 6.51781 8.8749 7.47036 7.88311C8.42292 6.89131 8.42292 5.2833 7.47036 4.2915Z"
    />
  </svg>
</template>
